module.exports = __webpack_public_path__ + "static/media/58.e1e44a71.webp";